import Video from "./Video";
import "../sass/Gallery.scss";

let projets = [];

export default function Gallery({etatGalerie, toggleLightbox, etatProjetChoisi }) {

    const [indexProjetChoisi, setIndex] = etatProjetChoisi;
    console.log(indexProjetChoisi);

    projets = etatGalerie.fields.projets;

    return (
        <div className="Gallery">
            <h3>{etatGalerie.fields.titre}</h3>
            <div className="projets">
                {projets.map((unProjet, index) =>
                    <Video key={unProjet.sys.id} index={index} gererClicProjet={() => { setIndex(index); toggleLightbox(); }} toolTip={unProjet.fields.titre} videoUrl={unProjet.fields.videoGameplay.fields.file.url} gameUrl={unProjet.fields.lienDuJeu} title={unProjet.fields.titre} />
                )}
            </div>
        </div>

    );
}